export default {
  title: 'Bannières',
  actions: {
    create: 'Créer une bannière',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette bannière?',
    delete: 'Supprimer',
    cancel: 'Annuler',
    save: 'Sauvegarder'
  },
  error: {
    url: {
      invalid: 'Veuillez fournir un (domaine/url) valide pour la question ci-dessus'
    },
    pathTarget: {
      start: "Le chemin doit commencer par \'/\'",
      all: 'Si vous voulez cibler tout le chemin, préférez utiliser l\'option ci-dessus -any page-',
      double: 'Le chemin ne peut pas avoir de double //'
    }
  }
}



// WEBPACK FOOTER //
// ./src/translations/fr/banner.js